
import Vue from 'vue';
import App from './App';
import router from './router';
import globalData from '@/components/common/globaldata/global.data';
import ZkTable from 'vue-table-with-tree-grid';

Vue.use(ZkTable);
Vue.use(globalData);
Vue.prototype.dateFormatA = function (row, column) {
  let date = row[column.property];
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}
Vue.prototype.dateFormatB = function (row, column) {
  let date = row[column.property];
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM-DD');
}

Vue.prototype.dateFormatYYYYMMDD = function (date) {
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM-DD');
}
import Axios from 'axios';
import ElementUI, {
  Message
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import moment from 'moment';
Vue.use(ElementUI, {
  size: 'small'
});

ElementUI.Table.props.stripe = { type: Boolean, default: true }

Vue.filter('productStatus', function (x) {

  let statusList = [
    {
      id: 1,
      text: "待审核",
    },
    {
      id: 2,
      text: "待上架",
    },
    {
      id: 3,
      text: "审核不通过",
    },
    {
      id: 4,
      text: "上架中",
    },
    {
      id: 5,
      text: "已下架",
    },
  ];
  const rs = statusList.filter((item) => {
    return item.id === x;
  });

  if (rs != null && rs.length > 0) {
    return rs[0].text;
  }
})
//判空
Vue.prototype.isEmptyObjVue = function (obj) {
  if (obj == null || obj == undefined || ("" + obj) == "") {
    return true;
  }
  return false;
};
Vue.prototype.formateDay = function (date) {
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM-DD');
}

Vue.prototype.formateMonth = function (date) {
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM');
}
Vue.prototype.formateTime = function (date) {
  if (Vue.prototype.isEmptyObjVue(date)) {
    return '';
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}
Vue.prototype.$axios = Axios;

Vue.config.productionTip = false
let apiUrl = process.env.adminUrl;
Axios.defaults.timeout = 300000; //设置请求时间
Axios.defaults.baseURL = apiUrl;
var loading;
function startLoading() {
  loading = (new Vue()).$loading({
    lock: true,
    text: "拼命加载中...",
    background: "rgba(0,0,0,0.4)"
  });
}

function endLoading() {
  loading.close();
}
Vue.prototype.formatMinute = function (duration) {
  if (!duration) return "00小时00分00秒";


  let day = parseInt(duration / (60 * 60 * 24))
  let h = parseInt((duration % (60 * 60 * 24)) / (60 * 60))
  let m = parseInt((duration - h * 60 * 60 - day * (60 * 60 * 24)) / 60)
  let s = (duration % 60).toFixed(0);

  h = h.toString().length < 2 ? "0" + h.toString() : h.toString();
  m = m.toString().length < 2 ? "0" + m.toString() : m.toString();
  s = s.toString().length < 2 ? "0" + s.toString() : s.toString();

  return h + '小时' + m.toString() + '分' + s.toString() + '秒';

}
Axios.interceptors.request.use(
  config => {

    startLoading();
    config.headers.token = window.localStorage.getItem('token');
    // config.headers.token = token;
    return config;
  },
  err => {
    Message.error('请求超时!');
    return Promise.reject(err);
  });

//axios统一错误处理
Axios.interceptors.response.use(data => {

  endLoading();
  // if (data.status && data.status == 200) {
  // }
  if (data.data.errno == 501) {
    Message.error({ message: '服务端错误: ' + data.data.errmsg });
  }
  if (data.data.errno == 502) {
    Message.error({ message: '服务端错误: ' + data.data.data + data.data.errmsg });
  }
  if (data.data.errno == 503) {
    Message.error({ message: '服务器异常，请联系相关人员！' })
  }
  if (data.data.errno == 400) {
    // Message.error({ message: '权限不够' });
    Message.error({ message: data.data.errmsg });
  }

  if (data.data.errno == 401) {
    //去登录
    //如果当前页面不是/login
    if (window.location.pathname != '/login') {
      window.location.href = '/login';
    }
  }
  // return data;
  if (data.data.errno == 0) {
    return data
  } else if (data.data.errno == -1) {
    Message.error({
      message: data.data.errmsg
    });
    return Promise.reject(data);
  } else {
    return Promise.reject(data);
  }
}, err => {
  (new Vue()).$message({
    showClose: true,
    message: '接口错误,请稍后重试',
    type: 'error'
  });
  endLoading();
  return Promise.reject(err);
})

// wujie 环境：启用 appendToBody + 修正 Popper 定位
// 非 wujie 环境：关闭 appendToBody 即可
if (window.$wujie) {
  // wujie 下保持 appendToBody 为 true（默认值），由下方 Popper 补丁修正定位
  // 不设置 false，否则 popper 在组件内部会被 overflow:hidden 裁剪

  var JsonPopper = require('element-ui/lib/utils/popper')
  if (JsonPopper && !JsonPopper.__wujiePatched) {
    JsonPopper.__wujiePatched = true
    var origGetPosition = JsonPopper.prototype._getPosition
    var origGetOffsets = JsonPopper.prototype._getOffsets
    var origGetBoundaries = JsonPopper.prototype._getBoundaries

    // 对 body 下的 popper 使用 fixed 定位，绕开 offsetParent 在 iframe+shadowDOM 下的坐标偏移
    JsonPopper.prototype._getPosition = function (popper, reference) {
      if (popper && popper.parentNode === document.body) return 'fixed'
      return origGetPosition.call(this, popper, reference)
    }

    // 基于 viewport 坐标重新计算 offsets，不依赖 offsetParent
    // 正确处理 placement 的对齐后缀（-start / -end）
    JsonPopper.prototype._getOffsets = function (popper, reference, placement) {
      if (!popper || popper.parentNode !== document.body) {
        return origGetOffsets.call(this, popper, reference, placement)
      }
      var parts = placement.split('-')
      var basePlacement = parts[0]
      var alignment = parts[1] // 'start' | 'end' | undefined
      var popperOffsets = { position: 'fixed' }
      var refRect = reference.getBoundingClientRect()

      // 获取 popper 尺寸（含 margin）
      var _d = popper.style.display, _v = popper.style.visibility
      popper.style.display = 'block'
      popper.style.visibility = 'hidden'
      var cs = window.getComputedStyle(popper)
      var pw = popper.offsetWidth + (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0)
      var ph = popper.offsetHeight + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0)
      popper.style.display = _d
      popper.style.visibility = _v

      var referenceOffsets = {
        width: refRect.width, height: refRect.height,
        top: refRect.top, left: refRect.left,
        bottom: refRect.bottom, right: refRect.right
      }

      if (basePlacement === 'left' || basePlacement === 'right') {
        // 水平方向弹出
        popperOffsets.left = basePlacement === 'left' ? refRect.left - pw : refRect.right
        if (alignment === 'start') {
          popperOffsets.top = refRect.top
        } else if (alignment === 'end') {
          popperOffsets.top = refRect.bottom - ph
        } else {
          popperOffsets.top = refRect.top + refRect.height / 2 - ph / 2
        }
      } else {
        // 垂直方向弹出（top / bottom）—— el-select 等组件默认 bottom-start
        popperOffsets.top = basePlacement === 'top' ? refRect.top - ph : refRect.bottom
        if (alignment === 'start') {
          popperOffsets.left = refRect.left
        } else if (alignment === 'end') {
          popperOffsets.left = refRect.right - pw
        } else {
          popperOffsets.left = refRect.left + refRect.width / 2 - pw / 2
        }
      }
      popperOffsets.width = pw
      popperOffsets.height = ph

      return { popper: popperOffsets, reference: referenceOffsets }
    }

    // 修正 viewport 边界计算
    JsonPopper.prototype._getBoundaries = function (data, padding, boundariesElement) {
      if (data.offsets.popper.position !== 'fixed') {
        return origGetBoundaries.call(this, data, padding, boundariesElement)
      }
      var boundaries = {}
      if (boundariesElement === 'window') {
        var body = document.body, html = document.documentElement
        var h = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
        var w = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth)
        boundaries = { top: 0, right: w, bottom: h, left: 0 }
      } else if (boundariesElement === 'viewport') {
        var vw = document.documentElement.clientWidth || window.innerWidth || 0
        var vh = document.documentElement.clientHeight || window.innerHeight || 0
        boundaries = { top: 0, right: vw, bottom: vh, left: 0 }
      } else {
        if (boundariesElement && typeof boundariesElement.getBoundingClientRect === 'function') {
          var rect = boundariesElement.getBoundingClientRect()
          boundaries = { top: rect.top, right: rect.right, bottom: rect.bottom, left: rect.left }
        } else {
          boundaries = { top: 0, right: window.innerWidth, bottom: window.innerHeight, left: 0 }
        }
      }
      boundaries.left += padding
      boundaries.right -= padding
      boundaries.top += padding
      boundaries.bottom -= padding
      return boundaries
    }
  }
}

Vue.config.productionTip = false


// 获取 wujie 传递的 props（被 wujie 加载时可用）
const wujieProps = window.$wujie && window.$wujie.props || {}

let instance = new Vue({
  router,
  data() {
    return {
      parentStore: wujieProps.parentStore || null,
    }
  },
  render: (h) => h(App),
}).$mount('#sub-worker');

// 监听主应用通过 wujie bus 发来的路由跳转指令
if (window.$wujie) {
  let fromMainApp = false

  window.$wujie.bus.$on('sub-worker-route', (data) => {
    const { path, query } = typeof data === 'string' ? { path: data, query: {} } : data
    const current = router.currentRoute
    if (current.path !== path || JSON.stringify(current.query) !== JSON.stringify(query || {})) {
      fromMainApp = true
      router.push({ path, query: query || {} }).catch(() => {
        fromMainApp = false
      })
    }
  })

  // 子应用内部路由变化时，通知主应用同步 URL 和侧边栏
  router.afterEach((to) => {
    if (fromMainApp) {
      fromMainApp = false
      return
    }
    window.$wujie.bus.$emit('sub-route-change', {
      name: 'sub-worker',
      path: to.path,
      query: to.query
    })
  })
}
